import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import WeexModal from "../weexModais/WeexModal";
import InteressesConfirmacaoModal from '../weexModais/InteressesConfirmacaoModal';
import AgendaService from "../../services/AgendaService";
import PreSelecaoInteressesService from "../../services/PreSelecaoInteressesService";
import {useStore} from 'react-redux';
import "./Interesses.css";

const Interesse = (props) => {
	const history = useHistory();
	const preSelecaoInteressesService = new PreSelecaoInteressesService();
	const agendaService = new AgendaService();
	const i18n = useStore().getState().i18n;
	const [interesse, setInteresse] = useState([""]);
	const [processando, setProcessando] = useState(false);
	const [erro, setErro] = useState({
		isWrong: false,
		titulo: "",
		mensagem: "",
		voltar: false,
	});
	const [salvando, setSalvando] = useState({
		isSaved: false,
		titulo: "",
		mensagem: "",
	});

	const [confirmando, setConfirmando] = useState({
		isConfirm: false,
		titulo: "",
		mensagem: "",
		voltar: false,
	});

	
	
	const handleChangeInteresse = (event) => {
		if (props.canSelectInterets) {
			const { name, value, checked } = event.target;

			if (checked) {
				setInteresse([
					...interesse,
					{
						name: name,
						uuid: value,
					},
				]);
			} else {
				setInteresse(
					interesse.filter(function (val) {
						return val.uuid !== value;
					})
				);
			}
		}
	};

	const confirmacaoDeEnvioDeInteresses = () =>{
		setConfirmando({
			isConfirm: true,
			titulo: i18n.message("interesse.selecaoObrigatoria.mensagemConfirmaTitulo", "Confirma seleção de interesses?"),
			mensagem: i18n.message("interesse.selecaoObrigatoria.mensagemConfirmaConteudo", "Você não poderá alterar mais tarde seus interesses. Deseja Continuar?")
		})
	}

	const voltarInteresse = () => {
		if (confirmando.isConfirm === true) {
			setConfirmando({ isConfirm: false });
		}
	}

	const submitInteresse = (event) => {
		event.preventDefault();

		if(!interesse.length){
			return
		}

		if(interesse.length > props.daysOfEvent ){
			setErro({
				isWrong: true,
				titulo: i18n.message("interesse.erro.aoAdicionarInteresse.titulo", "Erro ao adicionar interesse"),
				mensagem: i18n.message("interesse.erro.quantidadeDeInteresses.mensagem", "Você deve selecionar no máximo " + props.daysOfEvent + " temas de interesse para continuar."),
				voltar: true,
			});
			return
		}
		preSelecaoInteressesService.selecaoDeInteresses(
			interesse,
			(erro, sucesso) => {
				if (erro) {
					setErro({
						isWrong: true,
						titulo: i18n.message("interesse.erro.aoAdicionarInteresse.titulo", "Erro ao adicionar interesse"),
						mensagem: i18n.message("interesse.erro.quantidadeDeInteresses.mensagem", "Você deve selecionar no máximo " + props.daysOfEvent + " temas de interesse para continuar."),
						voltar: true,
					});
					setSalvando({ isSaved: false });
				}
				if (sucesso) {
					setInteresse(sucesso);
					agendaService.atualizarInteresse(true);
					setProcessando(false);
					setErro({ isWrong: false });
					setSalvando({
						isSaved: true,
						titulo: i18n.message("interesse.sucesso.interesseAdicionado.titulo", "Interesses adicionados"),
						mensagem: i18n.message("interesse.sucesso.interessesSalvos.mensagem", "Os interesses foram salvos com sucesso"),
					});
				}
			}
		);
	};

	const callbackModal = () => {
		if (erro.isWrong === true) {
			setErro({ isWrong: false });
			history.push("/interests");
		}
	};

	const callbackModalSuccess = () => {
		if (salvando.isSaved === true) {
			setSalvando({ isSaved: false });
			history.push("/");
		}
	};

	if (!processando) {
		setProcessando(true);
		setSalvando({ isSaved: false });
		agendaService.agendaCorrente((erro, interesseJaSelecionado) => {
			if (interesseJaSelecionado) {
				let interesseEditado = interesseJaSelecionado.interests;
				setInteresse(interesseEditado);
			}
			if (erro) {
				setErro(erro);
			}
		});
	}

	const osInteresses = props.campanha.map((i) => {
		let clicked;

		return (
			<div className="container-interesse" key={i.uuid}>
				{interesse.map((e) => {
					if (i.uuid === e.uuid) {
						clicked = !clicked;
					}
				})}
				<label className="title-interesse" htmlFor={i.uuid}>
					{i.name}
				</label>
				<label className="switch-interesse">
					<input
						id={i.uuid}
						className="checkbox-interesse"
						type="checkbox"
						name={i.name}
						value={i.uuid}
						checked={clicked}
						onChange={handleChangeInteresse}
					/>
					<span className="slider-interesse round"></span>
				</label>
			</div>
		);
	});

	const osInteressesDesabilitados = props.campanha.map((i) => {
		let clicked;

		return (
			<div className="container-interesse" key={i.uuid}>
				{interesse.map((e) => {
					if (i.uuid === e.uuid) {
						clicked = !clicked;
					}
				})}
				<label className="title-interesse" htmlFor={i.uuid}>
					{i.name}
				</label>
				<label className="switch-interesse">
					<input
						id={i.uuid}
						className="checkbox-interesse"
						type="checkbox"
						name={i.name}
						value={i.uuid}
						checked={clicked}
						disabled={!props.canSelectInterets}
					/>
					<span className="slider-interesse round"></span>
				</label>
			</div>
		);
	});

	return (
		<>
		{
			confirmando.isConfirm === true ?
			(
				<InteressesConfirmacaoModal
					submitInteresse={submitInteresse}
					voltarInteresse={voltarInteresse}
					visivel={confirmando !== null}
					titulo={confirmando.titulo}
					conteudo={confirmando.mensagem}
				/>
			) : null
		}
			{salvando.isSaved === true ? (
				<WeexModal
					callback={callbackModalSuccess}
					visivel={salvando !== null}
					titulo={salvando.titulo}
					conteudo={salvando.mensagem}
				/>
			) : null}
			{erro.isWrong === true ? (
				<WeexModal
					callback={callbackModal}
					visivel={erro !== null}
					titulo={erro.titulo}
					conteudo={erro.mensagem}
				/>
			) : null}
			<form className="interesse" onSubmit={submitInteresse}>
				<div className="interesse-container">
					{props.canSelectInterets ? osInteresses : osInteressesDesabilitados}
				</div>
				
				<hr />
				{
					// se for fora do periodo da pre campanha
					props.requiredInterests === true && props.beginDate <= props.now ? 
					(
					<div className="interesse-btn-container" onClick={confirmacaoDeEnvioDeInteresses}>
						<p className={props.canSelectInterets ? "interesse-salvar salvar-obrigatório" : "interesse-salvar-disabled"}>
							{salvando.isSaved === false ? (i18n.message("interesse.salvar", "SALVAR")) : (i18n.message("interesse.salvando", "SALVANDO..."))}
						</p>
					</div>
					)
					:
					(
					<div className="interesse-btn-container">
						<button className={props.canSelectInterets ? "interesse-salvar" : "interesse-salvar-disabled"} type="submit" disabled={!props.canSelectInterets}>
							{salvando.isSaved === false ? (i18n.message("interesse.salvar", "SALVAR")) : (i18n.message("interesse.salvando", "SALVANDO..."))}
						</button>
					</div>
					)
				}
			</form>
		</>
	);
};

export default Interesse;
